export default __webpack_public_path__ + "static/nicole2-d8d83ee694e9ffb302f320466a86d69a.jpg";